import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * @typedef {object} typegame
 * @property {boolean} typegame.light
 * @property {boolean} typegame.mountain
 * @property {boolean} typegame.sky
 * @property {boolean} typegame.temple
 * @property {boolean} typegame.tree
 */

/**
 * The game data.
 * @type {typegame}
 * @constant
 */
const game = {

    'light': false,
    'sky': false,

    'mountain': false,
    'temple': false,
    'tree': false,
};

/**
 * The state manager of the game data.
 * @type {import('@hypercubejs/hypercubejs').State<typegame>}
 * @constant
 */
const stategame = new HYPERCUBEJS.State(game);

export {

    stategame
};

export default stategame;
